import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f3b7fb63911b0014c38f52/mofagov/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f3b7fb63911b0014c38f52/mofagov/src/components/home/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f3b7fb63911b0014c38f52/mofagov/src/components/layout/Navbar.tsx");
